import { Card, Flex } from 'antd';
import { BaseButton } from 'components/button/button-base';
import { Text } from 'components/mvp-typography';
import { PaymentDetails } from 'features/clinic/billing/_components/payment-details';
import { ClinicianContext } from 'lib/hooks/use-resolveCurrentClinicInfo';

/**
 * This page needs to load the organisation context for the organiastion that was created in the last step.
 * Cases
 * 1. The user is new and has a single organisation. This is the easiest.
 * 2. The user is not new and has multiple organisations. This is the hard part.
 *
 * Ideally the last step passes the current organisation ID into this one
 */
export function OrganisationOnboardingBillingSetupPage(props: {
  organisationId: string;
  goToNextStep: () => void;
}) {
  return (
    <div>
      <ClinicianContext
        value={{
          clinicIds: [],
          clinicNames: [],
          currentClinic: props.organisationId,
          errors: [],
          hasErrors: false,
          isFetched: true,
          isFetching: false,
          isLoading: false,
          ...({} as any)
        }}
      >
        <Flex vertical gap={16}>
          <Text>
            Configure your billing method here. You will be required to complete
            the billing step inside the app before using assessments.
          </Text>
          <Card>
            <PaymentDetails redirectUrlOverride={window.location.origin} />
          </Card>
          <Flex justify="end">
            <BaseButton onClick={() => props.goToNextStep()}>
              Skip for now
            </BaseButton>
          </Flex>
        </Flex>
      </ClinicianContext>
    </div>
  );
}
